import { render, staticRenderFns } from "./SocialValue.vue?vue&type=template&id=13a19a3a&scoped=true&"
import script from "./SocialValue.vue?vue&type=script&lang=js&"
export * from "./SocialValue.vue?vue&type=script&lang=js&"
import style0 from "./SocialValue.vue?vue&type=style&index=0&id=13a19a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a19a3a",
  null
  
)

export default component.exports